export const DEFAULT_CID = {
	jd: '1316',
	tmall: '1801',
	douyin: '20085',
	custom: 'model_example_snacks',
	amazon_us: '1111111100000033',
}
export const PLAT_LIST = [
	{
		value: 'jd',
		label: '京东',
	},
	{
		value: 'tmall',
		label: '天猫',
	},
	{
		value: 'douyin',
		label: '抖音',
	},
	{
		value: 'amazon_us',
		label: '亚马逊',
	},
	{
		value: 'custom',
		label: '自定义',
	},
]
